import {Question} from '@/state/models/Question';
import {Choice} from '@/state/models/Choice';

export class QuestionMultipleChoice extends Question {
    public choices: Choice[];

    constructor(id: number, text: string, choices: Choice[], correctAnswerValue: string) {
        super(id, text, 'multichoice', correctAnswerValue);
        this.choices = choices;
    }
}
